import servise from '@/router/axios'

export const setDeduct = (data) => {
  return servise({
    url: '/report/detail/buckle',
    method: 'PUT',
    data
  })
}

export const setStatus = (data) => {
  return servise({
    url: '/report/detail/is/right',
    method: 'PUT',
    data
  })
}
